import { useState } from "react";
import { Assets } from "../../../assets";
import "./style.scss";
import { Spin, Tooltip } from "antd";
import { downloadPDF } from "../../../utilities/downloadPdf";
import { LoadingOutlined } from "@ant-design/icons";

type PropsType = {
  uri: string;
  params?: any;
};

export const ExportPdf = ({ uri, params }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onClickExportHandler = async () => {
    try {
      setIsLoading(true);
      await downloadPDF(uri, "", params);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Spin
        indicator={<LoadingOutlined spin />}
        size="small"
        spinning={isLoading}
      >
        <Tooltip title="Export PDF">
          <img
            alt="export_pdf"
            className="icon-export__image"
            src={Assets.icons.png.pdf}
            onClick={onClickExportHandler}
          />
        </Tooltip>
      </Spin>
    </>
  );
};
